import React, { Fragment } from 'react';

import {
  AdvertiseWithUsButton,
  BuyingABusinessSection,
  ManageMyAdsButton,
  SignOutButton,
} from '../Dropdown/DropdownButtons';
import { NavHeading } from '../Dropdown/DropdownHeading';

import { DropdownMenuContainer } from './DropdownMenuContainer';
import { DropdownMenuDivider } from './DropdownMenuDivider';

interface DropdownMenuLoggedInProps {
  variant: 'logged-in-buyer' | 'logged-in-client';
  baseUrl: string;
  advertiserCentreUrl: string;
}
export const DropdownMenuLoggedIn = ({
  variant,
  baseUrl,
  advertiserCentreUrl,
}: DropdownMenuLoggedInProps) => (
  <DropdownMenuContainer>
    {variant === 'logged-in-client' && (
      <Fragment>
        <NavHeading>Advertiser Centre</NavHeading>
        <ManageMyAdsButton advertiserCentreUrl={advertiserCentreUrl} />

        <DropdownMenuDivider />
      </Fragment>
    )}

    <BuyingABusinessSection baseUrl={baseUrl} />

    <DropdownMenuDivider />

    {variant === 'logged-in-buyer' && (
      <Fragment>
        <NavHeading>Selling a business</NavHeading>
        <AdvertiseWithUsButton baseUrl={baseUrl} />

        <DropdownMenuDivider />
      </Fragment>
    )}

    <SignOutButton baseUrl={baseUrl} />
  </DropdownMenuContainer>
);
